import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@foss/legion-ui/styles.css'
import './global.css'
import { App } from './App'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
